// extracted by mini-css-extract-plugin
module.exports = {"custom":"custom_custom__P0_IU"};